module.exports = __webpack_public_path__ + "media/assets/icons/funnel/move-icon-3d00069290c7b8913da9f30277c1a147.svg";